module.exports = __webpack_public_path__ + "close.svg?73f82a5e600b081384b3aab154497ee9";